import type { CSSProperties, ReactNode } from "react";
import ActiveGameZoneScreenWithNavigation from "../../components/ActiveGameZoneScreenWithNavigation";


const defaultContentClassName =
  "relative z-[1] flex h-full w-full max-w-full min-w-0 flex-col overflow-x-hidden overflow-y-auto text-white";

interface GameScreenFrameProps {
  children: ReactNode;
  showNavigation?: boolean;
  background?: string;
  beforeBackground?: ReactNode;
  bottomOverlay?: ReactNode;
  afterContent?: ReactNode;
  wrapContent?: boolean;
  contentStyle?: CSSProperties;
}

export default function GameScreenFrame({
  children,
  showNavigation,
  background = "var(--color-fullscreen-surface)",
  beforeBackground,
  bottomOverlay,
  afterContent,
  wrapContent = true,
  contentStyle,
}: GameScreenFrameProps) {
  return (
    <ActiveGameZoneScreenWithNavigation showNavigation={showNavigation}>
      {beforeBackground}
      <div
        className="absolute inset-0 z-0"
        style={{ background }}
      />
      {bottomOverlay}
      {wrapContent ? (
        contentStyle ? (
          <div style={contentStyle}>
            {children}
          </div>
        ) : (
          <div className={defaultContentClassName}>
            {children}
          </div>
        )
      ) : (
        children
      )}
      {afterContent}
    </ActiveGameZoneScreenWithNavigation>
  );
}
